import styled from 'styled-components'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(25, 25, 39, 0.7);
  transition: opacity 0.3s linear;
  opacity: ${({ isOpened }) => (isOpened ? '1' : '0')};
  pointer-events: ${({ isOpened }) => (isOpened ? 'all' : 'none')};
`
